module.exports = __webpack_public_path__ + "static/img/07-01.f2a5168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/07-01.png
// module id = jTq5
// module chunks = 0